import React, { useState } from "react";
import Layout from "@/components/layout";
import Footer from "@/components/footer";
import HeaderContent from "@/components/HeaderContent";
import FormacaoQuePrepara from "@/components/FormacaoQuePrepara";
import EscolaAcolhedora from "@/components/VideoInstitutional";
import CalendarioEscolar from "@/components/CalendarioEscolar";
import SliderCalendarioEscolar from '@/components/Slider';
import JornadaCompleta from "@/components/JornadaCompleta";
import Depoimentos from "@/components/Depoimentos";
import PreMatricula from '@/components/PreMatricula';
import LojaArabe from "@/components/LojaArabe";
import TesteArabe from "@/components/TesteArabe";
import HeaderOne from "@/components/header-one";
import SearchContextProvider from "@/context/search-context";
import MenuContextProvider from "@/context/menu-context";
import OndeEstamos from '@/components/OndeEstamos';
import FazemosParteDaRedeBertoni from '@/components/FazemosParteDaRedeBertoni';
import ModalQuiz from "../components/QuizArabe";
import SEO from '../components/seo'

const HomePage = () => {
  const [openQuiz, setOpenQuiz] = useState(false);
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout>
          <SEO
            title="Escola Árabe Bertoni | Infantil e Fundamental em Foz do Iguaçu"
            description="Educação Infantil e Fundamental em Foz do Iguaçu com ensino trilíngue, valores islâmicos e identidade árabe, ao lado da Mesquita. Conheça a escola."
            pathname="/"
          />
          <HeaderOne />
          <HeaderContent />
          <FormacaoQuePrepara />
          <EscolaAcolhedora />
          <CalendarioEscolar />
          <SliderCalendarioEscolar />
          <JornadaCompleta />
          <Depoimentos />
          <PreMatricula />
          <LojaArabe />
          <TesteArabe onOpenQuiz={() => setOpenQuiz(true)} />
          <ModalQuiz open={openQuiz} onClose={() => setOpenQuiz(false)} />
          <OndeEstamos />
          <FazemosParteDaRedeBertoni />
          <Footer /> 
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  )
}

export default HomePage;
